import { render, staticRenderFns } from "./tplSearch.vue?vue&type=template&id=bc0ee182&scoped=true&"
import script from "./tplSearch.vue?vue&type=script&lang=js&"
export * from "./tplSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0ee182",
  null
  
)

export default component.exports